export default __webpack_public_path__ + "static/can-i-force-you-to-meditate-social-image-d1985889a9d7b2d2107c5ce36047b4c7.jpeg";